import { useMutation, useQueryClient } from "@tanstack/react-query";
import { useProject } from "../project";
import { apiClient } from "../service/tekkr-service";

interface ApplyDocumentUpdateInput {
    proposalId: string;
    editIds: string[];
}

export interface ApplyDocumentUpdateResult {
    appliedCount: number;
    skippedCount: number;
    documentUrl: string;
}

export function useApplyDocumentUpdateMutation() {
    const queryClient = useQueryClient();
    const { project } = useProject();

    return useMutation({
        mutationFn: async (input: ApplyDocumentUpdateInput): Promise<ApplyDocumentUpdateResult> => {
            const res = await apiClient.applyDocumentUpdate({
                params: { projectId: project.id },
                body: input,
            });
            if (res.status !== 200) {
                throw new Error("Failed to apply document update");
            }
            return res.body;
        },
        onSuccess: async () => {
            await queryClient.invalidateQueries({
                queryKey: ["project", project.id, "attachments"],
            });
        },
    });
}
